/**
 * WheeldatabaseList
 */
import Flickity from './../../Libraries/Flickity';
import {each} from "lodash/collection";

export default class WheeldatabaseList {
    constructor(selector) {
        this.$plugin = $(selector);
        if (!this.$plugin.length) return;

        this.$filter = this.$plugin.find('[data-tncp-wheeldatabaselist="filter"]');
        this.$vehicletypefilter = this.$plugin.find('[data-tncp-wheeldatabaselist="vehicletypefilter"]');
        this.$result = this.$plugin.find('[data-tncp-wheeldatabaselist="results"]');

        this.$selectorFilterForm = '[data-tncp-wheeldatabaselist="filterForm"]';
        this.$selectorVehicleTypeFilterForm = '[data-tncp-wheeldatabaselist="vehicleTypeFilterForm"]';

        // Timer für verzögertes Overlay
        this.overlayTimer = null;

        this.loadFilterSettings();
        this.disableForm(this.$plugin.find(this.$selectorVehicleTypeFilterForm), true, false);
        this.$plugin.find('[data-powerview-options]').hide();
        this.setEventHandler();
    }

    setEventHandler() {
        //reset form
        this.$plugin.on('click', '[data-tncp-resetform="true"]', (event) => {
            event.preventDefault();
            this.resetForm(this.$selectorFilterForm);
            this.resetForm(this.$selectorVehicleTypeFilterForm);
            this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][InstallationCase]"]').val('TTG');
            this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][Acceptancefree]"]').val(0);
            this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][Snowchains]"]').val(0);
            this.$plugin.find('[data-powerview-options]').hide();
        });

        // filter submit
        this.$plugin.on('submit', this.$selectorFilterForm, (event) => {
            event.preventDefault();
            if(this.checkRequiredFields()) {
                this.$plugin.find('[data-tncp-pagination-value]').val('');
                this.loadVehicleTypeFilterSettings();
            }
        });

        // filter submit on enter
        this.$filter.find('input:not([type])').on('keypress', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                this.$filter.find('[data-tncp-wheeldatabaselist="filterForm"]').submit();
            }
        });

        // vehicle type filter submit
        this.$plugin.on('submit', this.$selectorVehicleTypeFilterForm, (event) => {
            event.preventDefault();
            if(this.checkRequiredFields()) {
                this.$plugin.find('[data-tncp-pagination-value]').val('');
                //if disabled
                if(this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][VehicleProducer]"]').is(':disabled')) {
                    this.toggleLoadingState(true, true);
                    this.loadVehicleTypeFilterSettings(() => {
                        this.setVehicleProducerFilter();
                        this.getListResults();
                    });
                }else{
                    this.setVehicleProducerFilter();
                    this.getListResults();
                }
            }
        });

        // pagination trigger
        this.$plugin.on('click', '[data-tncp-pagination-page]', (event) => {
            let $el = $(event.currentTarget);
            let value = $el.attr('data-tncp-pagination-page');
            this.$plugin.find('[data-tncp-pagination-value]').val(value);
            this.getListResults().then(() => {
                $('html,body').animate({
                    scrollTop: $('[data-scrollto-target]').offset().top
                });
            });
        });

        this.$plugin.on('mouseleave', '.close-tooltip', (event) => {
            $('[data-toggle="tooltip"]').tooltip('hide');
        });

        // onchange installationcase
        this.$plugin.on('change', '[name="tx_tuevnordcustomerportal_api[filter][InstallationCase]"]', function () {
            let $el = $(this);
            let value = $el.val();
            let tooltip = $el.closest('div[data-tooltip="installationCase"]').attr('data-title-'+value);
            $el.closest('div[data-tooltip="installationCase"]').attr('title', tooltip);
        });
    }

    async loadFilterSettings() {
        try {
            const url = this.$plugin.find('[data-tncp-wheeldatabaselist-filtersettings-xhr]').data('tncp-wheeldatabaselist-filtersettings-xhr');
            const response = await window.xhrRequest({ url, method: 'GET' });
            this.$filter.html(response.data.content);

            if (this.$plugin.find(this.$selectorFilterForm).length) {
                this.setFilter(this.$selectorFilterForm);
                this.onWheeldataChangeResetVehicleFilter();
                this.initMultipleSelectModal();
                this.handleWheelConnectionChange();
            }
        } catch (error) {
            console.error('Fehler beim Laden der Filtereinstellungen:', error);
        }

        $('[data-toggle="tooltip"]').tooltip();

        $('.js-popup-link--inline').magnificPopup({
            type: 'inline',
            midClick: true,
            callbacks: {
                close: function() {
                    setTimeout(function () {
                        $('.showVehicleAreaButton').focus();
                    }, 100);
                }
            }
        });
    }

    checkRequiredFields() {
        if($('#modal_CenterWholeVA').find('input:checked').length === 0){
            $('div[data-tncp-open-modal="modal_CenterWholeVA"]').css('background-color', '#f8cccc');
            return false;
        }else{
            $('div[data-tncp-open-modal="modal_CenterWholeVA"]').css('background-color', '#fff');
        }
        this.$plugin.find(this.$selectorFilterForm)[0].reportValidity();
        return this.$plugin.find(this.$selectorFilterForm)[0].checkValidity();
    }

    initMultipleSelectModal() {
        let modals = $('[data-tncp-open-modal]');

        modals.each(function () {
            let $field = $(this),
                identifier = $field.data('tncp-open-modal'),
                qualifiedIdentifier = '#' + identifier;

            // Add popup functionality
            $field.magnificPopup({
                items: {
                    src: qualifiedIdentifier
                },
                type: 'inline',
                midClick: true,
                callbacks: {
                    beforeOpen: function() {
                        // Block opening of modal if element is disabled
                        if ($field.hasClass('disabled') || $field.attr('disabled')) {
                            return false;
                        }
                    }
                }
            });

            function updateSelectedValues(checkBoxValue) {
                let maxSelection = $(qualifiedIdentifier).data('max-selection');
                let checkedInputs = $(qualifiedIdentifier).find('input:checked[value!="0"]');

                if(typeof checkBoxValue !== 'undefined') {
                    checkDefaultOption(checkBoxValue.val());

                    if (maxSelection > 0 && checkedInputs.length > maxSelection) {
                        $(checkBoxValue).prop('checked', false);
                        return;
                    }
                }

                if (maxSelection > 0 && checkedInputs.length <= maxSelection) {
                    $(qualifiedIdentifier).find('input:checkbox[value!="0"]:not(:checked)').remove('disabled', true);
                    $(qualifiedIdentifier).find('input:checkbox[value!="0"]:not(:checked)').each(function () {
                        let checkboxLabel = ($('label[for="' + $(this).attr('id') + '"]'));
                        checkboxLabel.removeClass('field-inactive');
                    });
                    addSelection();
                    updateLimitedSelection();
                }

                if (maxSelection > 0 && checkedInputs.length === maxSelection) {
                    $(qualifiedIdentifier).find('input:checkbox[value!="0"]:not(:checked)').add('disabled', true);
                    $(qualifiedIdentifier).find('input:checkbox[value!="0"]:not(:checked)').each(function () {
                        let checkboxLabel = ($('label[for="' + $(this).attr('id') + '"]'));
                        checkboxLabel.addClass('field-inactive');
                    });
                    addSelection();
                    updateLimitedSelection();
                }

                if(typeof checkBoxValue === 'undefined') {
                    addSelection();
                }
            }

            function updateLimitedSelection() {
                let maxSelection = $(qualifiedIdentifier).data('max-selection');
                let checkedInputs = $(qualifiedIdentifier).find('input:checked[value!="0"]').length;
                let modalMessageBox = $(qualifiedIdentifier).find('[data-modal-message]');

                modalMessageBox.html('Max: ' + checkedInputs + ' / ' + maxSelection);
            }

            function addSelection() {
                let selectedLabels = [];
                $(qualifiedIdentifier).find('input:checked').each(function () {
                    let checkboxLabel = $.trim($('label[for="' + $(this).attr('id') + '"]').html());
                    selectedLabels.push(checkboxLabel);
                });
                $field.find('.selected-values').remove();
                if (selectedLabels.length) {
                    $field.append('<span class="selected-values">' + selectedLabels.join(', ') + '</span>');
                }
            }

            function checkDefaultOption(checkBoxValue) {
                if($(qualifiedIdentifier).find('input[value="0"]:checked').length > 0 && checkBoxValue === '0') {
                    $(qualifiedIdentifier).find('input[value!="0"]:checked').prop('checked', false);
                }else if($(qualifiedIdentifier).find('input[value!="0"]:checked').length > 0) {
                    $(qualifiedIdentifier).find('input[value="0"]').prop('checked', false);
                }
            }

            // Display data initially
            updateSelectedValues();

            // Update data onclick
            $(qualifiedIdentifier).find('input').on('change', function () {
                updateSelectedValues($(this));
            });

            $(qualifiedIdentifier).find('[data-tncp-multiselect-submit]').on('click', function(event) {
                event.preventDefault();
                if($(qualifiedIdentifier).find('input:checked').length === 0){
                    $(qualifiedIdentifier).find('input[value="0"]').prop('checked', true);
                }
                updateSelectedValues();
                $field.magnificPopup('close');
            });
        });
    }


    onWheeldataChangeResetVehicleFilter(){
        this.$filter.find('input, select').on('change keydown', () => {
            this.$result.hide();
            this.$plugin.find('[data-powerview-options]').hide();
            //this.$vehicletypefilter.hide();
            this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][VehicleProducer]"]').val('');
            this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][VehicleType]"]').val('');
            this.disableForm(this.$plugin.find(this.$selectorVehicleTypeFilterForm), true, false);
        });
    }

    async loadVehicleTypeFilterSettings(callback = null) {
        this.$result.hide();
        this.toggleLoadingState(true);

        const $form = this.$plugin.find(this.$selectorFilterForm);
        const serializedFilters = btoa($form.serialize());
        const formData = new FormData();
        formData.append("tx_tuevnordcustomerportal_api[filter]", serializedFilters);

        try {
            this.disableForm($form);
            window.tncpRouter.setRoute(serializedFilters, false);
            $('#csv-filter-input').val(serializedFilters);
            $('#brakecontours-filter-input').val(serializedFilters);

            const response = await window.xhrRequest({ url: $form.attr('action'), method: 'POST', data: formData });
            this.$vehicletypefilter.html(response.data.content).show();
            this.toggleLoadingState(false);

            if(response.data.resultsFound) {

                this.copyFormElements(this.$plugin.find('[data-all-forms="filterForm"]'), this.$plugin.find('[data-all-forms="copyFilterForm"]'));

                let vehicleProducer = this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][VehicleProducer]"]');
                vehicleProducer.change(() => {
                    this.vehicleTypeHandler(vehicleProducer);
                });

                this.handleEmptyVehicleProducer();

                // vehicle type filter submit on enter
                this.$vehicletypefilter.find('input:not([type])').on('keypress', (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.$vehicletypefilter.find(this.$selectorVehicleTypeFilterForm).submit();
                    }
                });

                if (typeof callback === 'function') {
                    callback(response);
                }else{
                    this.$plugin.find('[data-powerview-options]').hide();
                }
            }else{
                if (typeof callback === 'function') {
                    this.$plugin.find(`[data-tncp-wheeldatabaselist="skeletonresults"]`).hide();
                }
            }
        } catch (error) {
            console.error('Fehler beim Laden des Fahrzeugtypenfilters:', error);
        }
        this.disableForm($form, false);
        $('.js-popup-link--inline').magnificPopup({
            type: 'inline',
            midClick: true
        });
    }

    copyFormElements(formFrom, formTo) {
        formTo.find("input[type='hidden']").remove();

        // Alle relevanten Inputs und Selects aus formFrom holen
        formFrom.find("input, select").each(function () {
            let name = $(this).attr("name");
            let type = $(this).attr("type");
            let value = $(this).val();

            if (!name) return; // Falls kein Name vorhanden, überspringen

            // Checkboxen speziell behandeln
            if (type === "checkbox") {
                if(!$(this).is(":checked")) {
                    value = '';
                }
            }

            if(value) {
                // Neues Hidden-Input für formTo erstellen und hinzufügen
                $("<input>")
                    .attr("type", "hidden")
                    .attr("name", name)
                    .val(value)
                    .appendTo(formTo);
            }
        });
    }

    resetForm($selector) {
        const $form = this.$plugin.find($selector);
        let $filters = $form.find('[name^="tx_tuevnordcustomerportal_api[filter]"]');
        $filters.each((index,element) => {

            // remove value from hidden, text and selectboxes
            if (element.type === 'hidden' || element.type === 'text' || element.type === 'select-one') {
                $(element).val('')
            }

            // uncheck checkboxes / radio buttons
            if (element.type === 'checkbox' || element.type === 'radio') {
                $(element).prop('checked', false)
            }

        })

        // iterate through multiselect indicator fields
        let $multiselect = $form.find('[data-tncp-multiselect-indicator]');
        $multiselect.each((index,element) => {
            $(element).html("")
        })

        // triggers change on selectboxes
        $form.find('select').trigger('change');

        this.$result.hide();
    }

    async getListResults() {
        this.toggleLoadingState(true, true);

        const $form = this.$plugin.find(this.$selectorVehicleTypeFilterForm);
        const serializedFilters = btoa($form.serialize());
        const formData = new FormData();
        formData.append("tx_tuevnordcustomerportal_api[filter]", serializedFilters);

        try {
            this.disableForm($form);
            window.tncpRouter.setRoute(serializedFilters, false);
            $('#csv-filter-input').val(serializedFilters);
            $('#brakecontours-filter-input').val(serializedFilters);

            const response = await window.xhrRequest({ url: $form.attr('action'), method: 'POST', data: formData });
            this.$result.html(response.data.content).show();
            this.toggleLoadingState(false, true);
            this.disableForm($form, false);

            if (response.data.resultsFound > 0) {
                this.$plugin.find('[data-powerview-options]').show();
                new Flickity().processBar();
            } else {
                this.$plugin.find('[data-powerview-options]').hide();
            }

            $('.js-popup-link--inline').magnificPopup({
                type: 'inline',
                midClick: true
            });

            $('[data-toggle="tooltip"]').tooltip();
        } catch (error) {
            console.error('Fehler beim Laden der Ergebnisse:', error);
        }
    }

    toggleLoadingState(loading, isResult = false) {
        const section = isResult ? 'results' : 'vehicletypefilter';
        this.$plugin.find(`[data-tncp-wheeldatabaselist="${section}"]`).toggle(!loading);
        this.$plugin.find(`[data-tncp-wheeldatabaselist="skeleton${section}"]`).toggle(loading);

        if (loading) {
            this.startDelayedOverlay();
        } else {
            this.hideLoadingAnimation();
        }
    }

    setFilter(selector) {
        const serializedString = atob(window.tncpRouter.getRoute()).replace(/\+/g, '%20');
        const formFieldArray = serializedString.split('&');

        if (!serializedString) return;

        const $form = this.$plugin.find(selector);
        $form[0].reset();

        formFieldArray.forEach((pair) => {
            const [name, value] = pair.split('=').map(decodeURIComponent);
            const $field = $form.find(`[name="${name}"]`);

            if ($field.length) {
                if ($field.is(':radio, :checkbox')) {
                    $field.filter(`[value="${value}"]`).prop('checked', true);
                } else {
                    $field.val(value);
                }
            }
        });
    }

    vehicleTypeHandler(vehicleProducer) {
        const selectedHersteller = vehicleProducer.val();
        const vehicleType = this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][VehicleType]"]');

        vehicleType.val('').find('optgroup, option').hide();

        if (selectedHersteller) {
            const filteredOptgroup = vehicleType.find(`optgroup[label="${selectedHersteller}"]`);
            if (filteredOptgroup.length) {
                filteredOptgroup.show().find("option").show();
                vehicleType.find('option:first').prop("selected", true);
            }
        }else{
            vehicleType.find('optgroup').show().find("option").show();
        }
    }

    handleEmptyVehicleProducer(){
        const vehicleProducer = this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][VehicleProducer]"]');
        const vehicleType = this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][VehicleType]"]');

        //wenn vehicleProducer count option > 1
        if(vehicleProducer.find('option').length > 1) {
            vehicleProducer.prop('disabled', false);
            vehicleType.prop('disabled', false);
        }else{
            vehicleProducer.prop('disabled', true);
            vehicleType.prop('disabled', true);
        }
    }

    setVehicleProducerFilter() {
        const vehicleType = this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][VehicleType]"]');
        //get selected vehicle type optgroup
        const selectedVehicleType = vehicleType.find('option:selected').closest('optgroup').attr('label');
        const vehicleProducer = this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][VehicleProducer]"]');
        //set selected vehicle producer to selectedVehicleType
        if(selectedVehicleType && vehicleProducer.val() === '') {
            vehicleProducer.val(selectedVehicleType);
        }
    }

    disableForm($form, disable = true, withButtons = true) {
        let $selectors = $form.find('input, select, textarea');
        if(withButtons) {
            $selectors = $form.find('button, input, select, textarea');
        }
        if (disable === true) {
            this.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'true');
            $selectors.attr('disabled', true);
        } else {
            this.$plugin.find('[data-form--isloading]').attr('data-form--isloading', 'false');
            $('body').find('.form-overlay-fullscreen').remove();
            $selectors.removeAttr('disabled');
        }
    }

    startDelayedOverlay() {
        if (this.overlayTimer) {
            clearTimeout(this.overlayTimer);
        }

        this.overlayTimer = setTimeout(() => {
            this.loadingAnimation();
        }, 1000);
    }

    handleWheelConnectionChange() {
        const $wheelConnectionVA = this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][WhellConnectionVA]"]');
        const $centerHoleModalVA = this.$plugin.find('[data-tncp-open-modal="modal_CenterWholeVA"]');
        const $wheelConnectionHA = this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][WhellConnectionHA]"]');
        const $centerHoleModalHA = this.$plugin.find('[data-tncp-open-modal="modal_CenterWholeHA"]');

        this.toggleCenterHoleModal($wheelConnectionVA, $centerHoleModalVA);
        this.toggleCenterHoleModal($wheelConnectionHA, $centerHoleModalHA);

        $wheelConnectionVA.on('change', () => {
            this.loadCenterHoleData($wheelConnectionVA.val(), 'VA');
        });

        $wheelConnectionHA.on('change', () => {
            this.loadCenterHoleData($wheelConnectionHA.val(), 'HA');
        });
    }

    resetCenterHoleField(wheelConnectionObj, centerHoleModal) {
        let wheelConnectionValue = wheelConnectionObj.val();
        let hasValidSelection = wheelConnectionValue && wheelConnectionValue !== '' && wheelConnectionValue !== '0';
        if(!hasValidSelection) {
            let wheelConnectionLabel = wheelConnectionObj.find('option:selected').text();
            centerHoleModal.find('.selected-values').remove();
            centerHoleModal.append('<span class="selected-values">' + wheelConnectionLabel + '</span>');
        }
    }

    async loadCenterHoleData(wheelConnection, axis) {
        let $filterWheelConnectionContainer = this.$plugin.find('[data-tncp-wheeldatabaselist="filterWheelConnection'+axis+'"]');
        let $wheelConnection = this.$plugin.find('[name="tx_tuevnordcustomerportal_api[filter][WhellConnection'+axis+']"]');
        let $centerHoleModal = this.$plugin.find('[data-tncp-open-modal="modal_CenterWhole'+axis+'"]');

        if (!wheelConnection || wheelConnection === '' || wheelConnection === '0') {
            let message = $filterWheelConnectionContainer.attr('data-message-choose-wheelConnection-first');
            $filterWheelConnectionContainer.find('#modal_CenterWhole'+axis+' [data-modal-content]').html(message);
            if(axis === 'HA') {
                this.resetCenterHoleField($wheelConnection, $centerHoleModal);
                this.toggleCenterHoleModal($wheelConnection, $centerHoleModal);
            }
            return;
        }

        try {
            const formData = new FormData();
            const filterString = `tx_tuevnordcustomerportal_api[filter][wheelConnection]=${wheelConnection}&tx_tuevnordcustomerportal_api[filter][axis]=${axis}`;
            const encodedFilter = btoa(filterString);
            formData.append("tx_tuevnordcustomerportal_api[filter]", encodedFilter);

            const actionUrl = this.$plugin.find('[data-tncp-wheeldatabaselist-filterwheelconnection-xhr]').data('tncp-wheeldatabaselist-filterwheelconnection-xhr');

            $centerHoleModal.addClass('disabled').attr('disabled', 'disabled');
            $centerHoleModal.addClass('field-inactive');

            const response = await window.xhrRequest({
                url: actionUrl,
                method: 'POST',
                data: formData,
            });

            if (response.data.content) {
                $filterWheelConnectionContainer.html(response.data.content);
                $filterWheelConnectionContainer.find('#modal_CenterWhole'+axis).data('max-selection', response.data.maximumSelection);
                this.initMultipleSelectModal();
                this.toggleCenterHoleModal($wheelConnection, $centerHoleModal);
            }

        } catch (error) {
            console.error('Fehler beim Laden der Mittelloch-Daten:', error);
        }
    }

    toggleCenterHoleModal($dropdown, $modal) {
        const selectedValue = $dropdown.val();
        const hasValidSelection = selectedValue && selectedValue !== '' && selectedValue !== '0';

        if (hasValidSelection) {
            $modal.removeClass('disabled').removeAttr('disabled');
            $modal.removeClass('field-inactive')
        } else {
            $modal.addClass('disabled').attr('disabled', 'disabled');
            $modal.addClass('field-inactive')
        }
    }


    loadingAnimation() {
        if (!$('body').find('.form-overlay-fullscreen').length) {
            const overlay = $(`
                    <div class="form-overlay-fullscreen"> 
                        <div class="loading-spinner"></div>
                    </div>
                `);

            $('body').append(overlay);
        }
    }

    hideLoadingAnimation() {
        if (this.overlayTimer) {
            clearTimeout(this.overlayTimer);
            this.overlayTimer = null;
        }

        $('body').find('.form-overlay-fullscreen').remove();
    }
}